import { paymentsClient } from '../axiosInstance';
import { IPriceListItem } from 'features/billing/prices/pricesTypes';

const pricesURL = process.env.REACT_APP_PAYMENTS_API + '/prices'

export const fetchPrices = async () => {
    return await paymentsClient.get<IPriceListItem[]>(pricesURL);
}

